module.exports = __webpack_public_path__ + "img/glogo254.88df6a72.png";